<script>
import DatePicker from "vue2-datepicker";
import number from "@/mixins/number";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";

export default {
  name: "WasteInputSP",
  components: {
    DatePicker,
  },
  mixins: [number, dailyReportControlRules],
  props: {
    wasteOrServiceByDailyReport: {
      type: Object,
      required: true,
    },
    dailyReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
    indexWasteOrService: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object | null,
    },
    canBeDelete: {
      type: Boolean,
      default: false,
    },
    carOptions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    scheduleIdWithSubId(wasteOrService) {
      return [
        this.dailyReport.schedule_id,
        wasteOrService?.daily_report_sub_id,
      ].filter(x => !!x).join('-')
    },
    wasteName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.waste?.name;
    },
    wasteCategoryName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.waste?.waste_category?.name_abbreviated;
    },
    changeZzManifestTypesTab(index) {
      this.wasteOrServiceByDailyReport.zz_manifest_type_id = index
    },
    changeZzQuantityConfirmationUnitIdTab(index) {
      this.wasteOrServiceByDailyReport.zz_quantity_confirmation_unit_id = index
    },
    changeZzValuablesInvolvedTypesTab(index) {
      this.wasteOrServiceByDailyReport.zz_valuables_involved_type_id = index
    },
    getProductName(estimate) {
      return estimate.invoice_product_name;
    },
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '06');
    },
    openModalSelectWaste() {
      this.$emit('openModalSelectWaste', this.wasteOrServiceByDailyReport);
    },
    removeWasteAfterTreatment(wasteOrService, wasteAfterTreatment) {
      if (!this.canSelectAfterTreatment) return;

      const index = wasteOrService.wastes_after_treatment_by_daily_report.findIndex(x => x.id === wasteAfterTreatment.id);
      if (index === -1) return;

      wasteOrService.wastes_after_treatment_by_daily_report.splice(index, 1);
    },
    deleteWaste() {
      this.$emit('deleteWaste', this.wasteOrServiceByDailyReport);
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    },
    messageForAfterTreatment(isGetColorClass = false){
      var isOwn = this.$constant.zzOwnId.is_own;
      let ownCount = this.wasteOrServiceByDailyReport.disposal_site_list_of_after.filter(function(item){
        return item.disposal_site_by_waste_category.vendor_site_after_treatment.zz_own_id == isOwn;
      }).length;
      // 処理後廃棄物処分場が全て他社：メッセージ無し
      // 処理後廃棄物処分場に自社があり、かつ自社が複数：メッセージと処分場表示
      // 処理後廃棄物処分場が1個所でありそれが自社：特殊メッセージ表示
      // 処理後廃棄物処分場に自社があり、自社が一つ：メッセージのみ表示
      if(ownCount === 0){
        return "";
      }else if(ownCount > 1){
        return isGetColorClass?"green":"※処分後情報に有価物があります（処分場："+this.wasteOrServiceByDailyReport.vendor_site.name_abbreviated+"）";
      } else if (this.wasteOrServiceByDailyReport.disposal_site_list_of_after.length == 1 && ownCount == 1){
        // ちょうど1の場合のメッセージを追加
        return isGetColorClass?"red":"※処分後情報は有価物のみに設定されています";
      }else if(ownCount > 0){
        return isGetColorClass?"green":"※処分後情報に有価物があります";
      }else{
        "";
      }
    },
  },
  computed: {
    isApproved() {
      if (this.dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal) {
        if (this.vendorSiteId) {
          return parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
        }

        return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
      }
      return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
        || parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
    zzManifestTypes() {
      return this.$store.getters['options/options_tables'].zz_manifest_types ?? [];
    },
    usersOption() {
      return this.dailyReport.schedule.assigned_staffs_by_schedule ?? [];
    },
    zzJwUnits() {
      const units = this.$store.getters['options/options_tables'].zz_jw_units ?? [];
      if (this.dailyReport.work_order_json.zz_work_order_type_id !== this.$constant.work_order_type.discharge) {
        return units.filter(x => x.id !== this.$constant.zzJUnits.piece);
      }

      return units;
    },
    zzValuablesInvolvedTypes() {
      return this.$store.getters['options/options_tables'].zz_valuables_involved_types ?? [];
    },
    canSelectAfterTreatment() {
      return this.wasteOrServiceByDailyReport.zz_valuables_involved_type_id !== this.$constant.zzValuablesInvolvedType.total;
    },
  },
  watch: {
    'wasteOrServiceByDailyReport.zz_valuables_involved_type_id': {
      handler: function (val) {
        if (val === this.$constant.zzValuablesInvolvedType.total) {
          this.wasteOrServiceByDailyReport.wastes_after_treatment_by_daily_report = [];
        }
      },
      deep: true,
    },
  },
}
</script>
<template>
  <b-row>
    <div class="d-flex justify-content-end mt-2" v-if="canBeDelete">
      <b-btn
        style="margin-right: 5px"
        class="btn-custom-red"
        size="sm"
        @click="deleteWaste"
        :disabled="isApproved"
      >
        <i class="fas fa-eraser"></i> 削除
      </b-btn>
    </div>
    <div class="wosdr" v-if="isDisplayControl('schedule_id')">
      <div class="label-wosdr">受付番号枝番：</div>
      <div class="content-wosdr">
				<span>
					{{ scheduleIdWithSubId(wasteOrServiceByDailyReport) }}
          <span v-if="isApproved">(承認済)</span>
				</span>
      </div>
    </div>
    <div class="wosdr" v-if="isDisplayControl('waste_service_name')">
      <div class="label-wosdr">廃棄物名称：</div>
      <div class="content-wosdr">
				<span>
					{{ wasteName(wasteOrServiceByDailyReport) }}
				</span>
      </div>
    </div>
    <div class="wosdr" v-if="isDisplayControl('waste_service_category_name')">
      <div class="label-wosdr">廃棄物種類：</div>
      <div class="content-wosdr">
				<span>
					{{ wasteCategoryName(wasteOrServiceByDailyReport) }}
				</span>
      </div>
    </div>
    <div class="wosdr" v-if="isDisplayControl('date_of_issue')">
      <div class="label-wosdr">交付年月日(引渡完了日)：</div>
      <div class="content-wosdr">
        <date-picker
          :disabled="isReadonly('date_of_issue') || isApproved"
          v-model="wasteOrServiceByDailyReport.date_of_issue"
          lang="ja"
          placeholder="YYYY-MM-DD"
          format="YYYY-MM-DD"
          value-type="YYYY-MM-DD"
          position="left"
        ></date-picker>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.date_of_issue`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.date_of_issue`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('zz_manifest_type_id')">
      <div class="label-wosdr">媒体：</div>
      <div class="content-wosdr">
        <div class="btn-group">
          <template v-for="(option, index) in zzManifestTypes">
            <input
              type="radio"
              :disabled="isReadonly('zz_manifest_type_id') || isApproved"
              class="btn-check"
              :id="`ZzManifestTypeIdBtnTab${indexWasteOrService}${index}`"
              :checked="wasteOrServiceByDailyReport.zz_manifest_type_id === option.id"
            >
            <label class="measurement-btn btn w-md-auto"
                   :class="wasteOrServiceByDailyReport.zz_manifest_type_id === option.id ? 'btn-primary' : 'btn-outline-primary'"
                   :for="`ZzManifestTypeIdBtnTab${indexWasteOrService}${index}`"
                   @click="changeZzManifestTypesTab(option.id)"
            >
              {{ option.manifest_type }}
            </label>
          </template>
        </div>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_manifest_type_id`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_manifest_type_id`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('manifest_number')">
      <div class="label-wosdr">マニフェスト番号：</div>
      <div class="content-wosdr">
        <b-form-input
          :disabled="isReadonly('manifest_number') || isApproved"
          v-model="wasteOrServiceByDailyReport.manifest_number"
          type="text"
        ></b-form-input>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.manifest_number`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.manifest_number`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('remarks')">
      <div class="label-wosdr">備考(管理番号等)：</div>
      <div class="content-wosdr">
        <b-form-input
          :disabled="isReadonly('remarks') || isApproved"
          v-model="wasteOrServiceByDailyReport.remarks"
          type="text"
        ></b-form-input>
      </div>
    </div>
    <b-row class="input-sp-error" v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.remarks`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.remarks`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('car_selected')">
      <div class="label-wosdr">車両番号選択：</div>
      <div class="content-wosdr">
        <b-form-select
          :disabled="isApproved"
          :id="'car_select_' + indexWasteOrService"
          :options="carOptions"
          v-model="wasteOrServiceByDailyReport.car_selected"
          value-field="id"
          text-field="display_name"
          class="form-select custom-select"
        ></b-form-select>
      </div>
    </div>
    <b-row class="input-sp-error" v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.car_selected`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.car_selected`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('user_id')">
      <div class="label-wosdr">運搬担当者 ：</div>
      <div class="content-wosdr">
        <b-form-select
          :disabled="isReadonly('user_id') || isApproved"
          :id="'department' + indexWasteOrService"
          :options="usersOption"
          v-model="wasteOrServiceByDailyReport.user_id"
          value-field="id"
          text-field="user_name"
          class="form-select custom-select"
        ></b-form-select>
      </div>
    </div>
    <b-row class="input-sp-error" v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.user_id`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.user_id`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('transport_completed_date')">
      <div class="label-wosdr">運搬終了日：</div>
      <div class="content-wosdr">
        <date-picker
          :disabled="isReadonly('transport_completed_date') || isApproved"
          v-model="wasteOrServiceByDailyReport.transport_completed_date"
          lang="ja"
          placeholder="YYYY-MM-DD"
          format="YYYY-MM-DD"
          value-type="YYYY-MM-DD"
          position="left"
        ></date-picker>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.transport_completed_date`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.transport_completed_date`][0] }}
      </div>
    </b-row>
    <div class="wosdr"
         v-if="isDisplayControl('measurement_quantity')">
      <div class="label-wosdr">確定数量：</div>
      <div class="content-wosdr">
        <b-form-input
          v-if="isDisplayControl('measurement_quantity')"
          :disabled="isReadonly('measurement_quantity') || isApproved"
          @keyup="setMinNumber($event)"
          v-model="wasteOrServiceByDailyReport.measurement_quantity"
          type="number"
          min="0"
          max="99999.999"
          class="input-sp-measurement-quantity"
        ></b-form-input>
      </div>
    </div>
    <b-row v-if="isDisplayControl('zz_quantity_confirmation_unit_id')" style="margin-bottom: 10px;">
      <div class="btn-group">
        <template v-for="(option,index) in zzJwUnits">
          <input type="radio"
                  class="btn-check"
                  :id="`ZzQuantityConfirmationUnitIdBtnTab${indexWasteOrService}${index}`"
                  :checked="option.id === wasteOrServiceByDailyReport.zz_quantity_confirmation_unit_id"
                  :disabled="isReadonly('zz_quantity_confirmation_unit_id') || isApproved"
          >
          <label class="measurement-btn btn w-md-auto"
                  :class="wasteOrServiceByDailyReport.zz_quantity_confirmation_unit_id === option.id ? 'btn-primary' : 'btn-outline-primary'"
                  :for="`ZzQuantityConfirmationUnitIdBtnTab${indexWasteOrService}${index}`"
                  @click="changeZzQuantityConfirmationUnitIdTab(option.id)"
          >
            {{ option.jw_unit }}
          </label>
        </template>
      </div>
    </b-row>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.measurement_quantity`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.measurement_quantity`][0] }}
      </div>
    </b-row>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_quantity_confirmation_unit_id`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_quantity_confirmation_unit_id`][0] }}
      </div>
    </b-row>
    <div class="input-sp-estimates" v-if="isDisplayControl('estimates')">
      <template
        v-for="(estimate, estimateIndex) in wasteOrServiceByDailyReport.estimates_by_daily_report"
      >
        <div>
          <div class="wosdr">
            <div class="label-wosdr">{{ getProductName(estimate) }}</div>
            <div class="content-wosdr" :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              <b-form-input
                class="input-field"
                :disabled="isReadonly('estimates.quantity') || isApproved"
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.quantity"
                min="0"
              ></b-form-input>
              <span>{{ getZzUnit(estimate) }}</span>
            </div>
            <b-row class="input-sp-error"
                  v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`]">
              <div class="error-message">
                {{
                  errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`][0]
                }}
              </div>
            </b-row>
          </div>
          <div class="wosdr">
            <div class="label-wosdr">空容器数量</div>
            <div class="content-wosdr">
              <b-form-input
                class="input-field"
                :disabled="true"
                :value="estimate.number_of_rental_containers"
                type="text"
                maxLength="50"
              ></b-form-input>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!wasteOrServiceByDailyReport.estimates_by_daily_report.length && !isLoading">
        <span>データなし。</span>
      </template>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('treatment_completed_date')">
      <div class="label-wosdr">処分終了年月日：</div>
      <div class="content-wosdr">
        <date-picker
          :disabled="isReadonly('treatment_completed_date') || isApproved"
          v-model="wasteOrServiceByDailyReport.treatment_completed_date"
          lang="ja"
          placeholder="YYYY-MM-DD"
          format="YYYY-MM-DD"
          value-type="YYYY-MM-DD"
          position="left"
        ></date-picker>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.treatment_completed_date`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.treatment_completed_date`][0] }}
      </div>
    </b-row>
    <div class="wosdr" v-if="isDisplayControl('zz_valuables_involved_type_id')">
      <div class="label-wosdr">
        <div class="measurement btn-group">
          <template v-for="(option,index) in zzValuablesInvolvedTypes">
            <input type="radio"
                   class="btn-check"
                   :id="`ZzValuablesInvolvedTypesBtnTab${indexWasteOrService}${index}`"
                   :checked="option.id === wasteOrServiceByDailyReport.zz_valuables_involved_type_id"
                   :disabled="isReadonly('zz_valuables_involved_type_id') || isApproved"
            >
            <label class="measurement-btn btn w-md-auto"
                   :class="option.id === wasteOrServiceByDailyReport.zz_valuables_involved_type_id ? 'btn-primary' : 'btn-outline-primary'"
                   :for="`ZzValuablesInvolvedTypesBtnTab${indexWasteOrService}${index}`"
                   @click="changeZzValuablesInvolvedTypesTab(option.id)"
            >
              {{ option.valuables_involved_type }}
            </label>
          </template>
        </div>
      </div>
    </div>
    <div class="wosdr" v-if="isDisplayControl('zz_valuables_involved_type_id')">
      <div class="label-wosdr">
        <div class="gap-2 valuable-involved-type-note"
                :class="messageForAfterTreatment(true)">
          {{ messageForAfterTreatment() }}
        </div>
      </div>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_valuables_involved_type_id`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.zz_valuables_involved_type_id`][0] }}
      </div>
    </b-row>
    <template v-if="isDisplayControl('wastes_after_treatment_by_daily_report')">
      <b-row class="mt-2">
        <div class="d-flex gap-3">
          <b-button
            variant="primary w-100"
            :disabled="isReadonly('wastes_after_treatment_by_daily_report') || isApproved || !canSelectAfterTreatment"
            @click="openModalSelectWaste(wasteOrServiceByDailyReport)"
          >
          <i class="fas fa-list-alt"></i>
            処理後廃棄物を選択する
          </b-button>
        </div>
      </b-row>
      <b-row class="mt-2">
        <div class="selected-vehicles d-flex gap-2 flex-wrap">
          <b-badge
            v-for="(waste_after_treatment, index_waste_after_treatment) in wasteOrServiceByDailyReport.wastes_after_treatment_by_daily_report"
            :key="`waste_after_treatment_${indexWasteOrService}_${index_waste_after_treatment}`"
            variant="primary"
          >
            {{ waste_after_treatment.name }}
            <span
              @click="removeWasteAfterTreatment(wasteOrServiceByDailyReport, waste_after_treatment)"
              class="badge badge-light badge-icon-custom"
            >×</span>
          </b-badge>
        </div>
      </b-row>
      <b-row>
        <div
          v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.wastes_after_treatment_by_daily_report`]"
          class="error-message"
        >
          {{
            errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.wastes_after_treatment_by_daily_report`][0]
          }}
        </div>
      </b-row>
    </template>
  </b-row>
</template>
<style lang="scss" scoped>
.input-sp-estimates {
  margin-bottom: 1rem;
  border: 2px solid #ccc;
  padding: 10px;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
}

.label-wosdr {
  padding: 10px 7px;
  font-weight: bold;
  min-width: 142px;
}

.content-wosdr {
  width: 100%;
  display: flex;
  align-items: center;
}

.wosdr {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.input-field {
  flex: 1;
  width: 60%;
  margin-right: 5px;
}

.measurement {
  display: flex !important;
  align-items: center;
  margin-left: auto;
}

.measurement-btn {
  margin: 0px 0px 0px 0px !important;
}

.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.input-sp-error {
  margin-left: -3px;
  margin-bottom: 20px;
}
.valuable-involved-type-note{
  font-size: large;
}
.red{
  color:red;
}
.green{
  color:green;
}
.bg_notice{
  background-color: yellow;
}
</style>
